export enum PurchaseDeliveryMethod {
  EMAIL = "EMAIL",
  MAIL = "MAIL",
  NONE = "NONE",
  PICKUP = "PICKUP",
}
